export class Base64 {
    private static _chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    private static _charsLookUp: Uint8Array;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static decode(base64: string): ArrayBuffer {
        Base64.init();

        let bufferLength = base64.length * 0.75;
        let len = base64.length;
        let i: number;
        let p = 0;
        let encoded1: number;
        let encoded2: number;
        let encoded3: number;
        let encoded4: number;

        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }

        const arraybuffer = new ArrayBuffer(bufferLength);
        const bytes = new Uint8Array(arraybuffer);
        const lookUp = Base64._charsLookUp;

        for (i = 0; i < len; i += 4) {
            encoded1 = lookUp[base64.charCodeAt(i)];
            encoded2 = lookUp[base64.charCodeAt(i + 1)];
            encoded3 = lookUp[base64.charCodeAt(i + 2)];
            encoded4 = lookUp[base64.charCodeAt(i + 3)];

            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }

        return arraybuffer;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static encode(arraybuffer: ArrayBuffer, offset: number, len: number): string {
        Base64.init();

        let bytes = new Uint8Array(arraybuffer, offset, len);
        let base64 = '';

        for (let i = 0; i < len; i += 3) {
            base64 += Base64._chars[bytes[i] >> 2];
            base64 += Base64._chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
            base64 += Base64._chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
            base64 += Base64._chars[bytes[i + 2] & 63];
        }

        if (len % 3 === 2) {
            base64 = base64.substring(0, base64.length - 1) + '=';
        } else if (len % 3 === 1) {
            base64 = base64.substring(0, base64.length - 2) + '==';
        }

        return base64;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private static init(): void {
        if (!Base64._charsLookUp) {
            Base64._charsLookUp = new Uint8Array(256);

            for (let i = 0; i < Base64._chars.length; i++) {
                Base64._charsLookUp[Base64._chars.charCodeAt(i)] = i;
            }
        }
    }
}